var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2933_7641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0257 13.8468L18.5948 17.4152L17.4157 18.5943L13.8473 15.0252C12.5196 16.0895 10.8682 16.6684 9.1665 16.666C5.0265 16.666 1.6665 13.306 1.6665 9.16601C1.6665 5.02602 5.0265 1.66602 9.1665 1.66602C13.3065 1.66602 16.6665 5.02602 16.6665 9.16601C16.6689 10.8677 16.09 12.5191 15.0257 13.8468ZM13.354 13.2285C14.4116 12.1409 15.0022 10.683 14.9998 9.16601C14.9998 5.94268 12.389 3.33268 9.1665 3.33268C5.94317 3.33268 3.33317 5.94268 3.33317 9.16601C3.33317 12.3885 5.94317 14.9993 9.1665 14.9993C10.6835 15.0017 12.1414 14.4111 13.229 13.3535L13.354 13.2285Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2933_7641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.927885579d597165327869a4239482ee.svg";
export { ForwardRef as ReactComponent };